import {GigyaModes} from '../utils/gigya';

const DEFAULT_FEATURES = {};

export default class Settings {
	private static _instance: Settings;

	memberId: number;
	breakpoints: Record<string, number>;
	sizeMapping: AnyObject;
	slots: Array<unknown>;
	user?: string;
	targeting: AnyObject;
	disablePSA: boolean;
	enableSafeFrame: boolean;
	lazyLoadThreshold: number | string | Record<string, number | string>;
	loadSlotBatchCount: number | Record<string, number>;
	features: {
		privacy?: boolean
		cxense?: boolean
		snowplow?: boolean
		gigya?: false | GigyaModes
		experiments?: boolean
		pageViewId?: boolean
	};
	slotNameMappings?: Record<string, Record<string, string | null> | string | null>;

	constructor(config) {
		_validatePropsExist(config, ['memberId', 'breakpoints', 'sizeMapping', 'slots']);

		if (typeof config.memberId !== 'number') {
			throw Error('memberId should be a number');
		}

		this.memberId = config.memberId;
		this.breakpoints = config.breakpoints;
		this.sizeMapping = config.sizeMapping;
		this.slots = config.slots;
		this.targeting = Object.assign({}, config.targeting);
		this.user = config.user;

		this.disablePSA = typeof config.disablePSA === 'undefined' ? true : Boolean(config.disablePSA);
		this.enableSafeFrame = typeof config.enableSafeFrame === 'undefined' ? true : Boolean(config.enableSafeFrame);

		this.lazyLoadThreshold = config.lazyLoadThreshold;

		if (_isValidLoadSlotBatchCount(config.loadSlotBatchCount)) {
			this.loadSlotBatchCount = config.loadSlotBatchCount;
		}

		this.features = Object.assign(DEFAULT_FEATURES, config.features);

		this.slotNameMappings = config.slotNameMappings;

		Settings._instance = this;
	}

	static getInstance() {
		return Settings._instance;
	}
}

function _isValidLoadSlotBatchCount(value) {
	if (typeof value === 'number') {
		return true;
	}

	if (typeof value === 'object') {
		if (value === null || Array.isArray(value)) {
			return false;
		}

		return Object.values(value).every(v => typeof v === 'number');
	}

	return false;
}

function _validatePropsExist(obj, props) {
	if (typeof obj === 'undefined') {
		throw Error('Missing settings');
	}

	props.forEach((prop) => {
		if (typeof obj[prop] === 'undefined') {
			throw Error(`Missing required setting: ${prop}`);
		}
	});
}
